import React, { useState } from "react";
import "../../Styles/Folder/ListViewofFolder.css";
import tagfileicon from "../../Assets/tagfileicon.svg";
import selecyedFormIcon from "../../Assets/selecyedFormIcon.png";
import FormListViewIcon from "../../Assets/FormListViewIcon.svg";

import edit_form from "../../Assets/edit_form.png";
import shear_form from "../../Assets/shear_form.png";
import AddToFolderForm from "../../Assets/AddToFolderForm.png";

import Excelicon from "../../Assets/Excelicon.png";
import excelIcon2 from "../../Assets/excelIcon2.png";
import pdgicon from "../../Assets/pdgicon.png";
import { useNavigate } from "react-router-dom";

const ListForm = ({
  folderDetails,
  folder,
  selectedFormIds,
  setSelectedFormIds,
}) => {
  const [showIcons, setShowIcons] = useState(null);
  const [openDropDown, setOpenDropDown] = useState(null);
  const navigate = useNavigate();

  const handelSelectedFomes = (formId) => {
    if (selectedFormIds.includes(formId)) {
      setSelectedFormIds(selectedFormIds.filter((id) => id !== formId));
    } else {
      setSelectedFormIds([...selectedFormIds, formId]);
    }
  };

  function formatUpdatedAt(date) {
    const options = { month: "short", day: "numeric", year: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString("en-US", options);
    return `Updated on ${formattedDate}`;
  }

  const [shaerDropDown, setShearDropDown] = useState(null);
  const [exportDropDown, setExportDropDown] = useState(null);
  const [exportTypeDropDown, setExportTypeDropDown] = useState(null);

  const handelShearDD = (option) => {
    setShearDropDown(option === shaerDropDown ? null : option);
  };

  const handelExport = (option) => {
    console.log("hello");
    if (exportDropDown === option) {
      setExportDropDown(null);
      setExportTypeDropDown(null);
    } else {
      setExportDropDown(option);
    }
  };
  const handelExportTypeDD = (option, parentOption, event) => {
    event.stopPropagation();
    if (exportTypeDropDown === option) {
      setExportTypeDropDown(null);
    } else {
      setExportTypeDropDown(option);
      setExportDropDown(parentOption); // Ensure the parent dropdown stays open
    }
  };

  const handelSelectAllForms = (checked) => {
    if (checked) {
      setSelectedFormIds(folderDetails.map((form) => form.formId));
    } else {
      setSelectedFormIds([]);
    }
  };
  return (
    <table className="table-container">
      <thead>
        <tr style={{ borderBottom: "1px solid #E9EAEC" }}>
          <th className="allselectcell">
            <div className="first-cell">
              <label class="checkbox-container-forlistof-form">
                <input
                  type="checkbox"
                  class="checkbox-input-forlistof-form"
                  checked={
                    folderDetails?.length > 0 &&
                    selectedFormIds?.length === folderDetails?.length
                  }
                  onChange={(e) => handelSelectAllForms(e.target.checked)}
                />
                <span class="checkbox-custom-forlistof-form"></span>
              </label>
            </div>
          </th>
          <th className="th">Form name</th>
          <th className="tableth th">Responses</th>
          <th className="form_edit_icons"></th>
          <th style={{ minWidth: "10%", width: "10%" }}>
            <div>Action</div>
          </th>
        </tr>
      </thead>
      <tbody>
        {folderDetails?.map((form, i) => (
          <tr
            style={{
              backgroundColor: selectedFormIds.includes(form.formId)
                ? "rgba(210, 229, 244, 1)"
                : "#fff",
            }}
            onMouseOver={() => setShowIcons(form.formId)}
            onMouseLeave={() => setShowIcons(null)}
          >
            <td
              style={{
                padding: "8px",
                borderTopLeftRadius: "10px",
                borderBottomLeftRadius: "10px",
              }}
              className="th"
            >
              <div className="first-cell">
                <label class="checkbox-container-forlistof-form">
                  <input
                    type="checkbox"
                    class="checkbox-input-forlistof-form"
                    checked={selectedFormIds.includes(form.formId)}
                    onChange={() => handelSelectedFomes(form.formId)}
                  />
                  <span class="checkbox-custom-forlistof-form"></span>
                </label>
              </div>
            </td>
            <td style={{ padding: "8px" }}>
              <div className="th name-container-selectedstate">
                <img
                  src={
                    selectedFormIds.includes(form.formId)
                      ? selecyedFormIcon
                      : FormListViewIcon
                  }
                  alt=""
                />
                <div className="name-container-formListt-view">
                  <strong>{form.formTitle}</strong>
                  <div className="tagContainer">
                    <div className="tag-count-container">
                      <img
                        src={tagfileicon}
                        alt="tagfileicon"
                        style={{ maxWidth: "80%", maxHeight: "80%" }}
                      />
                      {form.tagCount}
                    </div>
                    {formatUpdatedAt(form.formUpdated)}
                  </div>
                </div>
              </div>
            </td>
            <td className="th">{form.usersResponse} responses</td>
            <td>
              {showIcons === form.formId && openDropDown !== form.formId && (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>
                    <img src={edit_form} alt="" />
                  </span>
                  <span>
                    <img src={shear_form} alt="" />
                  </span>
                  <span>
                    <img src={AddToFolderForm} alt="" />
                  </span>
                </div>
              )}
            </td>
            <td
              className="centervalue"
              style={{
                borderTopRightRadius: "10px",
                borderBottomRightRadius: "10px",
                position: "relative",
              }}
            >
              <span onClick={() => setOpenDropDown(form.formId)}>⋮</span>
              {openDropDown === form.formId && (
                <div className="dropdown-menu-form-list-folder">
                  <ul>
                    <li
                      onClick={() =>
                        navigate(`/create-form/${form.formId}/question`)
                      }
                    >
                      View
                    </li>
                    <li>Edit</li>
                    <li>Clone</li>
                    <li
                      onClick={() => handelShearDD("Share")}
                      style={{ position: "relative" }}
                    >
                      Share
                      {shaerDropDown === "Share" && (
                        <ul className="share-dropdown">
                          <li>Copy link</li>
                          <li>Share as form</li>
                        </ul>
                      )}
                    </li>
                    <li>Rename</li>
                    <li
                      onClick={() =>
                        navigate(
                          `/create-form/${form.formId}/responses/dataview`
                        )
                      }
                    >
                      Submission
                    </li>
                    <li
                      onClick={() => handelExport("Export")}
                      style={{ position: "relative" }}
                    >
                      Export
                      {exportDropDown === "Export" && (
                        <ul className="export-dropDown">
                          <li style={{ position: "relative" }}>
                            <p
                              onClick={(e) =>
                                handelExportTypeDD("Question", "Export", e)
                              }
                            >
                              Export as question
                            </p>
                            {exportTypeDropDown === "Question" && (
                              <ul className="export-type-dropdown">
                                <li className="listofIconexport">
                                  <img src={Excelicon} alt="excelIcon" />
                                  Export as.xlsx
                                </li>
                                <li className="listofIconexport">
                                  <img src={excelIcon2} alt="excelIcon2" />{" "}
                                  Export as.csv
                                </li>
                                <li className="listofIconexport">
                                  <img src={pdgicon} alt="pdfIcon" /> Export
                                  as.pdf
                                </li>
                              </ul>
                            )}
                          </li>
                          <li
                            onClick={(e) =>
                              handelExportTypeDD("Response", "Export", e)
                            }
                            style={{ position: "relative" }}
                          >
                            Export as response
                            {exportTypeDropDown === "Response" && (
                              <ul className="export-type-dropdown-re">
                                <li className="listofIconexport">
                                  <img src={Excelicon} />
                                  Export as.xlsx
                                </li>
                                <li className="listofIconexport">
                                  <img src={excelIcon2} /> Export as.csv
                                </li>
                                <li className="listofIconexport">
                                  <img src={pdgicon} /> Export as.pdf
                                </li>
                              </ul>
                            )}
                          </li>
                        </ul>
                      )}
                    </li>
                    <li>Enable/disable</li>
                    <li>Delete</li>
                  </ul>
                </div>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ListForm;
